<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Checkmark from '$lib/icons/checkmark.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div class="flex items-center gap-x-3" use:editable={content}>
	<div class="flex h-6 w-6 items-center justify-center rounded-full bg-green-3">
		<Checkmark class="h-3 w-3 text-white" />
	</div>
	<p
		class="font-rhymes text-[24px]/[140%] tracking-[-.96px] lg:text-[28px]/[140%] lg:tracking-[-1.12px]"
	>
		{content.headline}
	</p>
</div>
